import { apiClient } from '../client'
import type { ApiResponse } from '../client.types'
import type { paths } from '../types'

type HealthCheckResponse = paths['/health']['get']['responses'][200]['content']['application/json']

/**
 * Health check API endpoint
 * GET /health - Check if API is running (public, no auth required)
 */

export const healthApi = {
  /**
   * Health check - verify API is running
   * GET /health
   */
  check(): Promise<ApiResponse<HealthCheckResponse>> {
    return apiClient.get<HealthCheckResponse>('/health')
  },
}
